export default __webpack_public_path__ + "media/images/elephant_ui_greeting-1e4cea1b277b1b5f8ce06ca9e59db1cb.svg";